import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PreparationPoste } from '@stockflow/offline-core';
import { AuthService } from '../services/auth.service';
import { proprietaireCourant } from '../services/proprietaire-courant';

/**
 * Une session valide ET un poste prepare pour son titulaire.
 *
 * Un poste de vente est partage : si l'utilisateur qui entre n'est pas celui dont
 * les donnees sont sur le poste, on passe d'abord par `/preparation-poste`, qui
 * les purge. Aucune route protegee ne se rend avant — voir `PreparationPoste`.
 *
 * Identite inconnue : on renvoie a la connexion plutot que de laisser entrer sans
 * pouvoir comparer. Entrer « par defaut » serait le trou que ce garde ferme.
 */
export const authGuard: CanActivateFn = async () => {
    // Toutes les injections AVANT le premier `await` : apres, le contexte
    // d'injection n'existe plus et `inject()` leve NG0203.
    const authService = inject(AuthService);
    const router = inject(Router);
    const poste = inject(PreparationPoste);

    const authenticated = await authService.checkSession();
    if (!authenticated) {
        router.navigate(['/login']);
        return false;
    }

    const proprietaire = await proprietaireCourant(authService);
    if (!proprietaire) {
        router.navigate(['/login']);
        return false;
    }
    if (poste.necessaire(proprietaire)) {
        router.navigate(['/preparation-poste']);
        return false;
    }
    return true;
};

/** Session valide, sans exiger que le poste soit prepare : c'est la page de preparation elle-meme. */
export const sessionSeuleGuard = async (): Promise<boolean> => {
    const authService = inject(AuthService);
    const router = inject(Router);

    const authenticated = await authService.checkSession();
    if (!authenticated) {
        router.navigate(['/login']);
        return false;
    }
    return true;
};
